import type { Workflow } from "./sync.types";

export class WorkflowError extends Error {}

export class NoDocumentIdError extends WorkflowError {
	public readonly tag = "no-document-id-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow) {
		super("No document ID found in sync snapshot");
		this.name = "NoDocumentIdError";
		this.workflow = workflow;
	}
}

export class NoWorkspaceError extends WorkflowError {
	public readonly tag = "no-workspace-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow) {
		super("No workspace found in sync snapshot");
		this.name = "NoWorkspaceError";
		this.workflow = workflow;
	}
}

export class NotAuthenticatedError extends WorkflowError {
	public readonly tag = "not-authenticated-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow) {
		super("Not authenticated");
		this.name = "NotAuthenticatedError";
		this.workflow = workflow;
	}
}

export class PlanNotAchievableError extends WorkflowError {
	public readonly tag = "plan-not-achievable-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow) {
		super("Plan not achievable");
		this.name = "PlanNotAchievableError";
		this.workflow = workflow;
	}
}

export class NoWorkspaceForRemoteRepoCreationError extends WorkflowError {
	public readonly tag = "no-workspace-for-remote-repo-creation-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow) {
		super("No workspace found in sync snapshot for remote repo creation");
		this.name = "NoWorkspaceForRemoteRepoCreationError";
		this.workflow = workflow;
	}
}

export class SetCollabTrackingBranchError extends WorkflowError {
	public readonly tag = "set-collab-tracking-branch-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow, error?: unknown) {
		super(error instanceof Error ? error.message : "Error setting collab tracking branch");
		this.name = "SetCollabTrackingBranchError";
		this.workflow = workflow;
	}
}

export class PushCollabBranchError extends WorkflowError {
	public readonly tag = "push-collab-branch-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow, error?: unknown) {
		super(error instanceof Error ? error.message : "Error pushing collab branch");
		this.name = "PushCollabBranchError";
		this.workflow = workflow;
	}
}

export class RemoteRepoDoesNotExistError extends WorkflowError {
	public readonly tag = "remote-repo-does-not-exist-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow) {
		super("Remote repository does not exist");
		this.name = "RemoteRepoDoesNotExistError";
		this.workflow = workflow;
	}
}

export class NoPagesFoundError extends WorkflowError {
	public readonly tag = "no-pages-found-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow) {
		super("No pages found to share. Please try sharing again.");
		this.name = "NoPagesFoundError";
		this.workflow = workflow;
	}
}

export class UnknownError extends WorkflowError {
	public readonly tag = "unknown-error" as const;
	public workflow: Workflow;
	constructor(workflow: Workflow, error?: unknown) {
		super(error instanceof Error ? error.message : "Unknown error");
		this.name = "UnknownError";
		this.workflow = workflow;
	}
}
